import "./user-type-card.scss";
import { FiArrowUpRight } from "react-icons/fi";

type UserTypeCardProps = {
  category: string;
  title: string;
  description: string;
};

export const UserTypeCard = (props: UserTypeCardProps) => {
  const { category, title, description } = props;

  return (
    <div className="user-type-card">
      <div className="user-type-card-header">
        <span className="user-type-card-category">{category}</span>
      </div>
      <div className="user-type-card-title-row">
        <h2>{title}</h2>
        <FiArrowUpRight className="user-type-card-arrow" aria-hidden="true" />
      </div>
      <p>{description}</p>
    </div>
  );
};
